<template>
  <v-card flat>
    <v-card :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'">
      <v-row class="no-gutters pb-5">
        <v-col cols="12" sm="12" md="6" lg="2">
          <v-select :disabled="$canRoute('client-tree-partner-tab') !== 1" v-model="selectedLevel" solo :items="levelSlots" item-text="text" item-value="value"
            append-icon="mdi-chevron-down" label="All Level" @change="handleLevelChange"
            class="custom-select"></v-select>
        </v-col>
        <v-col cols="12" sm="12" md="6" lg="3" :md="$canRoute('client-tree-partner-tab') !== 1 ? 6 : 4" :lg="$canRoute('client-tree-partner-tab') !== 1 ? 5 : 3">
          <v-text-field v-model="search" prepend-icon="mdi-magnify" label="Search..." single-line solo
            hide-details></v-text-field>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="5">
          <ul>
            <li>
              <span>Total Lot:</span>
              <span>{{ formattedAllNumber(clientTree?.individualTotals?.total_lot?.toFixed(2)) }}</span>
            </li>
            <li>
              <span>Total Invest:</span>
              <span>{{ formattedAllNumber(clientTree?.individualTotals?.total_deposit?.toFixed(2)) }}</span>
            </li>
            <li>
              <span>Total Trade:</span>
              <span>{{ formattedAllNumber(clientTree?.individualTotals?.total_trade) }}</span>
            </li>
            <li>
              <span>Commission:</span>
              <span>{{ formattedAllNumber(clientTree?.individualTotals?.total_commission?.toFixed(2)) }}</span>
            </li>
          </ul>
        </v-col>

        <v-col cols="12" sm="6" md="6" lg="2" v-if="$canRoute('client-tree-partner-tab') === 1">
          <v-dialog v-model="dialog" max-width="400" class="rounded-0">
            <template v-slot:activator="{ on, attrs }">
              <v-btn tile elevation="0" v-bind="attrs" v-on="on" class="mt-8 text-capitalize btn-account mb-0 mx-0"
                color="greenMain">
                + Add Client
              </v-btn>
            </template>
            <v-card rounded="0" width="400" :color="$vuetify.theme.dark ? '#111A26' : '#ffffff'">
              <v-card-title>Add Client</v-card-title>
              <v-card-text>Add a client to this partner</v-card-text>
              <v-card class="deposit-form px-1" :class="$vuetify.theme.dark ? 'blue-darken-1' : 'white-lighten-5'">
                <v-col cols="12">
                  <fieldset>
                    <legend>Input Client ID Number</legend>
                    <v-text-field v-model="clientId" type="number" label="Write Here" single-line solo hide-details
                      class="custom-select"></v-text-field>
                  </fieldset>
                </v-col>
              </v-card>
              <v-card-actions>
                <v-row dense>
                  <v-col cols="6">
                    <v-btn tile block @click="addClient" elevation="0" class="text-capitalize btn-account"
                      color="teal-lighten-1">Add</v-btn>
                  </v-col>
                  <v-col cols="6">
                    <v-btn block outlined @click="dialog = false" elevation="0" class="text-capitalize">Cancel</v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-col>
      </v-row>
    </v-card>
    <v-card class="pa-0 rounded-0 elevation-0" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
      <v-sheet class="transactionTable depositTabTable" :color="$vuetify.theme.dark ? '#162334' : '#E8F1F8'">
        <client-tree-tab-data-table :children="clientTree?.children" :search="search">
        </client-tree-tab-data-table>
      </v-sheet>
    </v-card>
  </v-card>
</template>

<script>
import ClientTreeTabDataTable from "./ClientTreeTabDataTable.vue";
import { mapState, mapActions } from "vuex";
import { PARTNERLIST__ACTIONS, COMMISSIONTREE__ACTIONS } from "@/store/action-types";
import { formatNumber } from "@/_helpers/formatNumber";
import toast from "@/services/Notification";

export default {
  components: { ClientTreeTabDataTable },
  data() {
    return {
      search: "",
      partner_id: "",
      selectedLevel: All,
      dialog: false,
      clientId: '',
    };
  },
  computed: {
    ...mapState("partnerlist", ["clientTree"]),
    ...mapState("commissiontree", ["levelCounts"]),
    levelSlots() {
      const totalLevels = this.levelCounts || 6;
      const levels = Array.from({ length: totalLevels }, (_, index) => ({
        text: `Level ${index + 1}`,
        value: index + 1
      }));
      return [
        { text: 'All Level', value: '' },
        ...levels
      ];
    },
  },

  methods: {
    ...mapActions("partnerlist", [PARTNERLIST__ACTIONS.CLIENTTREE, PARTNERLIST__ACTIONS.ADDCLIENTLEVELONE]),
    ...mapActions("commissiontree", [COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS]),

    formattedAllNumber(num) {
      return formatNumber(num || 0);
    },

    async handleLevelChange(level) {
      await this[PARTNERLIST__ACTIONS.CLIENTTREE]({ level: level, partner_id: this.partner_id });
    },

    addClient() {
      this[PARTNERLIST__ACTIONS.ADDCLIENTLEVELONE]({
        parent_ib: this.$route.query.id,
        child_ib: this.clientId
      })
      this.dialog = false

    }
  },

  async mounted() {
    this.partner_id = this.$route.query.id;
    await this[COMMISSIONTREE__ACTIONS.GETCOMMISSIONSETTINGS]();
    await this[PARTNERLIST__ACTIONS.CLIENTTREE]({ partner_id: this.$route.query.id });
  },
};
</script>